import { render, staticRenderFns } from "./BountyImageSwiper.vue?vue&type=template&id=6050887b&scoped=true"
import script from "./BountyImageSwiper.vue?vue&type=script&lang=js"
export * from "./BountyImageSwiper.vue?vue&type=script&lang=js"
import style0 from "./BountyImageSwiper.vue?vue&type=style&index=0&id=6050887b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050887b",
  null
  
)

export default component.exports